import * as Styles from '@screens/lp-default/components/timeline/styles';
import { timelineContent } from '@screens/lp-default/components/timeline/contents';
import Icon from '@components/icons';
import { IconsEnum } from '@components/icons/types';
import { useState } from 'react';
import { snowplowButtonClick } from '@analytics/snowplow/events';

export default function Timeline() {
  const [activeCard, setActiveCard] = useState('');

  const isCardActive = (index: number) => {
    return activeCard === `item-${index}`;
  };

  const getIsActive = (index: number) => {
    return isCardActive(index) ? IconsEnum.minus : IconsEnum.plus;
  };

  const handleClickCard = (cardName: string, index: number) => {
    if (!isCardActive(index)) {
      snowplowButtonClick('collapse', '/planos', cardName, 'content_section');
      setActiveCard(`item-${index}`);
      return;
    }
    setActiveCard('');
  };

  const handleClickBlur = () => {
    setActiveCard('');
  };

  const isBlurVisible = () => {
    if (activeCard === '') return false;
    return true;
  };

  return (
    <Styles.TimelineContainer>
      <Styles.TimelineBlur show={isBlurVisible()} data-testid="blur" onClick={() => handleClickBlur()} />
      <Styles.TimelineTitle>Processo de construção de conteúdo</Styles.TimelineTitle>
      <Styles.Timeline>
        <Styles.TimelineLine />
        <Styles.TimelineStepsContainer
          type="single"
          collapsible
          value={activeCard}
          onValueChange={(value) => setActiveCard(value)}
        >
          {timelineContent.map((content, index) => (
            <Styles.TimelineStep key={content.title} data-position={index} isOpen={isCardActive(index)}>
              <Styles.TimelineCard value={`item-${index}`} onClick={() => handleClickCard(content.title, index)}>
                <Styles.TimelineCardInteractive>
                  <Icon icon={getIsActive(index)} size={16} />
                </Styles.TimelineCardInteractive>
                <Styles.TimelineCardTitle>
                  <Styles.TimelineCardIcon>
                    <Icon icon={content.icon} size={20} />
                  </Styles.TimelineCardIcon>
                  {content.title}
                </Styles.TimelineCardTitle>
                <Styles.TimelineCardText>
                  {content.text}
                  <Styles.TimelineCardSubtext>Profissionais envolvidos:</Styles.TimelineCardSubtext>
                  <Styles.TimelineCardHighlightContainer>
                    {content.professionals.map((professional) => (
                      <Styles.TimelineCardHighlight key={`${content.title}-${professional}`}>
                        {professional}
                      </Styles.TimelineCardHighlight>
                    ))}
                  </Styles.TimelineCardHighlightContainer>
                </Styles.TimelineCardText>
              </Styles.TimelineCard>
              <Styles.TimelineConnector isOpen={isCardActive(index)} />
            </Styles.TimelineStep>
          ))}
        </Styles.TimelineStepsContainer>
      </Styles.Timeline>
    </Styles.TimelineContainer>
  );
}
